/**
 * Main Layout which describes the AutomationTab and implements all layout related views
 */

define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("automation-templates/mainLayout.tmpl");
    var NavigationView = require("automation-views/NavigationView");
    var ConvBuilderView = require("automation-views/ConvBuilderView");
    var LandingpageView = require("automation-views/LandingpageView");
    var BotPlatformView = require("automation-views/BotPlatformView");
    var AutomationLayout = {};
    var Loader = require("ui/loader/Loader");

    LE.module("LEAutomation", function (LEAutomation, LE, Backbone, Marionette, $, _) {
        AutomationLayout = Marionette.Layout.extend({
            className: 'automation-tab-layout',
            regions: {
                "landingPage": ".automation-landingpage",
                "botPlatform": ".automation-botplatform",
                "convBuilder": ".automation-conversationbuilder",
                "navRegion": ".automation-nav-region"
            },
            ui: {
                "landingPage": ".automation-landingpage",
                "botPlatform": ".automation-botplatform",
                "convBuilder": ".automation-conversationbuilder",
                "navRegion": ".automation-nav-region"
            },
            uiComponents: {
                navigation: {
                    type: NavigationView,
                    options: {
                        el: "view.ui.navRegion"
                    }
                },
                landingPage: {
                    type: LandingpageView,
                    options: {
                        el: "view.ui.landingPage"
                    }
                },
                convBuilder: {
                    type: ConvBuilderView,
                    options: {
                        el: "view.ui.convBuilder"
                    }
                },
                botPlatform: {
                    type: BotPlatformView,
                    options: {
                        el: "view.ui.botPlatform"
                    }
                }
            },
            template: template,

            onRender: function(){
                this.activateLandingPage();
                this.trigger('render:finished');
            },

            showLoader: function(options) {
                if (this.loaderCounter === 0) {
                    this.loader = new Loader(_.extend({
                        permutation: Loader.PERMUTATION.A,
                        zIndex: 999999,
                        el: this.el
                    }, options));
                    this.loader.render();
                }
                this.loaderCounter++;
            },

            closeLoader: function() {
                this.loaderCounter--;
                if (this.loaderCounter === 0) {
                    this.loader.close();
                }
                this.loaderCounter = _.max([this.loaderCounter, 0]);
            },

            activateLandingPage: function () {
                this._showLandingPage();
                this.uiComponents.navigation.activateLandingNav();
            },

            activateConvBuilderPage: function () {
                this._showConvBuilderPage();
                this.uiComponents.navigation.activateConvBuilderNav();
            },

            activateBotPlatformPage: function () {
                this._showbotPlatformPage();
                this.uiComponents.navigation.activateBotPlatform();
            },

            _showLandingPage: function () {
                this.ui.landingPage.toggleClass('active', true);
                this.ui.botPlatform.toggleClass('active', false);
                this.ui.convBuilder.toggleClass('active', false);
            },

            _showConvBuilderPage: function () {
                this.ui.landingPage.toggleClass('active', false);
                this.ui.botPlatform.toggleClass('active', false);
                this.ui.convBuilder.toggleClass('active', true);
            },

            _showbotPlatformPage: function () {
                this.ui.landingPage.toggleClass('active', false);
                this.ui.botPlatform.toggleClass('active', true);
                this.ui.convBuilder.toggleClass('active', false);
            }
        });
    });

    return AutomationLayout;
});
